import { http } from "./api";
import { TARIFS } from "./data";

const parsePrice = (s) => {
  if (typeof s === "number") return s;
  const n = parseFloat(String(s || "").replace("€", "").replace(/\s/g, "").replace(",", "."));
  return Number.isNaN(n) ? 0 : n;
};

function normalize(f) {
  if (f.priceNum !== undefined) return f; // déjà au format frontend
  const annual = !!f.annual;
  return {
    slug: f.slug,
    name: f.name,
    price: f.price,
    priceNum: parsePrice(f.price),
    period: f.period || "",
    annual,
    insurance: annual && f.insurance_price ? { price: f.insurance_price, priceNum: parsePrice(f.insurance_price) } : null,
    total: annual && f.total_price ? { price: f.total_price, priceNum: parsePrice(f.total_price) } : null,
    cta: f.cta || `Choisir ${f.name}`,
    highlight: !!f.highlight,
    features: f.features || [],
    payment_url: f.payment_url || "",
  };
}

export async function getFormulas() {
  try {
    const r = await http.get("/formulas");
    if (Array.isArray(r.data) && r.data.length) return r.data.map(normalize);
  } catch { /* fallback ci-dessous */ }
  return TARIFS.formulas;
}
